/*
 * @Author       : LQ
 * @Description  :
 * @version      : 3.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : jry
 * @lastTime     : 2025-08-17 17:23:53
 * @FilePath     : /uview-plus/libs/config/props/alert.js
 */
export default {
    // alert警告组件
    alert: {
        title: '',
        type: 'warning',
        description: '',
        closable: false,
        showIcon: false,
        effect: 'light',
        center: false,
        fontSize: 14,
        transitionMode: 'fade',
        duration: 0,
        icon: '',
        value: true
    }
}
